export const CRMSettingsTab = {
    DEAL_TYPE: 0,
    DEAL_PRIORITY: 1,
    DEAL_SOURCE: 2
}